import { SitesBuilderLibComponent } from '@3ddv/ngx-sites-builder-lib';
import { Injectable } from '@angular/core';
import { AsyncSubject, Observable } from 'rxjs';
import { MinisiteConfiguration, ToolsConfiguration, MapConfiguration } from '@3ddv/ngx-sites-builder-lib';
interface LocalStorageFile {
  tool_attr: LocalStorageFileAttr;
  img: string | ArrayBuffer;
}
interface LocalStorageFileAttr {
  key: string;
  filename: string;
  mime: string;
  tool: string;
}
@Injectable({
  providedIn: 'root',
})
export class SblibService {
  public sblib: SitesBuilderLibComponent;
  private mapConfig: MapConfiguration;
  private toolsConfig: ToolsConfiguration;
  private sblibReady$: AsyncSubject<boolean> = new AsyncSubject();

  constructor() { }

  public apply(toolsConfig: ToolsConfiguration, mapConfig?: MapConfiguration) {
    this.toolsConfig = toolsConfig;
    if (mapConfig) {
      this.mapConfig = mapConfig;
    }
    const minisiteConfiguration: MinisiteConfiguration = {
      mapConfig: this.mapConfig,
      toolsConfig: this.toolsConfig,
    };
    // save local storage
    // this.saveLocaStorage(minisiteConfiguration);

    // console.log('MinisiteConfiguration: ', minisiteConfiguration);
    this.sblib.saveSitedata = Object.assign({}, minisiteConfiguration);
  }

  private fileToUrl(tool_attr: LocalStorageFileAttr, input_file): Promise<LocalStorageFile> {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(input_file);
      reader.onload = function () {
        resolve({ tool_attr: tool_attr, img: reader.result });
      };
      reader.onerror = reject;
    });
  }

  private urlToFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  //deprecated
  private saveLocaStorage(minisite: MinisiteConfiguration) {
    // save logo image
    let promises = [];
    let keys = [];
    if (minisite.toolsConfig.logo.file) {
      let input_file = minisite.toolsConfig.logo.file;
      keys.push('logo');
      let meta: LocalStorageFileAttr = {
        key: 'logo',
        filename: input_file.name,
        mime: input_file.type,
        tool: 'logo',
      };
      let p1 = this.fileToUrl(meta, input_file);
      promises.push(p1);
    }
    // save configurations images
    if (minisite.toolsConfig.multivenue && minisite.toolsConfig.multivenue.venues) {
      let venuetabs = minisite.toolsConfig.multivenue.venues;
      if (venuetabs.length) {
        for (let i = 0; i < venuetabs.length; i++) {
          if (venuetabs[i].file) {
            let meta = {
              key: 'multivenue_' + i,
              filename: venuetabs[i].file.name,
              mime: venuetabs[i].file.type,
              tool: 'multivenue',
            };
            let p = this.fileToUrl(meta, venuetabs[i].file);
            promises.push(p);
            keys.push('multivenue_' + i);
          }
        }
      }
    }
    // Save master
    localStorage.setItem('minisiteInProgress', JSON.stringify(minisite));
    localStorage.setItem('minisiteInProgressToolKeys', JSON.stringify(keys));

    // Save images
    Promise.all(promises).then(res => {
      for (let i = 0; i < res.length; i++) {
        const tostore: LocalStorageFile = res[i];
        localStorage.setItem(tostore.tool_attr.key, JSON.stringify(tostore));
      }
    });
  }

  public recoverFromLocalStorage(storageData: LocalStorageFile) {
    // recover file from url
    return new Promise((resolve, reject) => {
      this.urlToFile(storageData.img, storageData.tool_attr.filename, storageData.tool_attr.mime)
        .then(res => {
          const resp = {
            meta: storageData.tool_attr,
            file: res,
          };
          resolve(resp);
        })
        .catch(err => {
          let resp = {
            meta: storageData.tool_attr,
            err: err,
          };
          reject(resp);
        });
    });
  }

  public setMapconfig(mapConfig: MapConfiguration) {
    this.mapConfig = mapConfig;
  }

  public getSblibReady$(): Observable<boolean> {
    return this.sblibReady$.asObservable();
  }
  public setSblibReady(): void {
    this.sblibReady$.next(true);
    this.sblibReady$.complete();
  }
}
